import DownloadInMemoryLink from '~/shared/components/downloadButton';
/* eslint-disable no-undef */
import { mdiArrowLeft } from '@mdi/js';

import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { format } from 'date-fns';

import { Document, Page, pdfjs } from 'react-pdf';

import { isCareplus } from '~/utils/constants/isCareplus';

import {
  ActionArea,
  Container,
  ExamList,
  Header,
  HeaderContainer,
  IconClick,
  IconContainer,
  NotFoundReaderPdfButton,
  PdfContainer,
  PrescriptionBackgroundHeader,
  StyledIcon,
  Title,
} from './styles';

import { LogoImage } from '~/shared/components/logoImage';
import api from '~/services/api';
import { Button, Icon, Link, Modal } from '~/shared/components';
import LoaderComponent from '~/shared/components/loader';
import { Theme } from '~/styles';
import validateHashOrigin from '~/utils';
import {
  getDocumentAuthorizationToken,
  setDocumentAuthorizationToken,
} from '~/utils/documentAuthorization';
import linkWhatsapp from '~/utils/linkWhatsapp';
import ExamItem from './components/examItem';
import PatientInformationCard from './components/patientInformationCard';
import ScheduleExamModal from './components/scheduleExamModal';
import BlurCard from '~/shared/components/blurCard';

const Exam = ({ title, token, id, selectedItem, validationKey }) => {
  const [documentsData, setDocumentsdata] = useState(null);
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [prescriptionData, setPrescriptionData] = useState(null);
  const [date, setDate] = useState('');
  const [modalIsOpen, setModalAsOpen] = useState(false);
  const [isScheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [examItems, setExamItems] = useState([]);
  const [pdfOpen, setpdfOpen] = useState(false);
  const [pdfModalTitle, setPdfModalTitle] = useState('');
  const [pdfItems, setpdfItems] = useState('');
  const [pdfItemShowing, setpdfItemShowing] = useState('');

  const isMobile = () => {
    if (typeof navigator === 'undefined') return;
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  const modalProps = {
    modalTitle: 'Agendar Exames',
    modalText: isCareplus ? (
      <>
        Agende seus exames pelo app Care Plus. Certifique-se de que ele já
        esteja instalado em seu celular.
      </>
    ) : (
      <>
        Deseja que o <span>Hospital Albert Einstein</span> entre em contato com
        você para agendar {selectedExam ? 'este exame' : 'estes exames'}?
      </>
    ),
    primaryButtonText: isCareplus
      ? 'Abrir app Care Plus'
      : 'Sim, quero agendar',
    secondaryButtonText: isCareplus ? 'Agora não' : 'Não, obrigado',
  };
  const allowScheduleCareplus = () => {
    return !isCareplus || isMobile();
  };

  const openCarePlusApp = () => {
    const link = 'http://ws.careplus.com.br/apicwi/redirect/blua.beep';
    globalThis.location.href = link;
  };
  const [isUnlockDocumentView, setUnlockDocumentView] = useState(false);
  const [medicalRecord, setMedicalRecord] = useState(null);

  const handleOpenPdf = () => {
    setPdfModalTitle('Exames solicitados');
    const accessToken = getDocumentAuthorizationToken();

    api
      .get(`/document/file/${validateHashOrigin(token)}/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(({ data: responseData }) => {
        setpdfItemShowing(responseData[0].url);

        const response = responseData.map((obj, index) => {
          return {
            ...obj,
            title: `${obj.title} ${index + 1}`,
          };
        });
        setpdfItems(response);
        setpdfOpen(true);
      });
  };
  React.useEffect(() => {
    api.get(`/document/${validateHashOrigin(token)}/${id}`).then(({ data }) => {
      setDocumentsdata(data);
    });
  }, [token, id]);
  const postData = async (value) => {
    return api
      .post(`/document/doctor/${validateHashOrigin(token)}/${id}`, {
        validation_key: value,
      })
      .then(({ data: responseData }) => {
        setDocumentAuthorizationToken(responseData?.accessToken);
        setMedicalRecord(responseData?.patient.medical_record);
        setUnlockDocumentView(true);
        setPrescriptionData(responseData);
        setModalAsOpen(!modalIsOpen);
        const dateFormated = format(
          new Date(responseData.medicalDocument.date),
          'MM/dd/yyyy'
        );
        setDate(dateFormated);
      });
  };

  const showScheduleButton =
    examItems &&
    examItems.length > 0 &&
    !!examItems[0].allow_contact_suggestion_for_scheduling &&
    !examItems.every((e) => !!e.concierge_integration) &&
    allowScheduleCareplus();

  const onDocumentLoadSuccess = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
  };

  const handleOpenScheduleModal = (examId) => {
    setScheduleModalOpen(true);
    setSelectedExam(examId || null);
  };
  const handleCloseScheduleModal = (approve) => {
    if (!approve) {
      return setScheduleModalOpen(false);
    }
    if (isCareplus) {
      openCarePlusApp();
      return;
    }
    let idsArray = [];
    if (selectedExam) {
      setExamItems(
        examItems.map((item) => {
          if (item.id === selectedExam) {
            item.concierge_integration = true;
          }
          return item;
        })
      );
      idsArray = [selectedExam];
    } else {
      setExamItems(
        examItems.map((item) => {
          if (!item.concierge_integration) {
            item.concierge_integration = true;
            idsArray.push(item.id);
          }
          return item;
        })
      );
    }
    api.post(`exam/concierge/${token}`, {
      id: idsArray,
    });
    return setScheduleModalOpen(false);
  };
  return (
    <Container>
      <HeaderContainer>
        <PrescriptionBackgroundHeader BackgroundHeight="55px" />
        <Header>
          <IconContainer>
            <IconClick
              onClick={() => {
                selectedItem();
              }}
            >
              <StyledIcon size={1} icon={mdiArrowLeft} />
            </IconClick>
          </IconContainer>
          <LogoImage />
        </Header>
      </HeaderContainer>
      <Title>{title}</Title>
      <PatientInformationCard
        title="Solicitação de Exames"
        documents={documentsData}
        date={date}
        postData={postData}
        validationKey={validationKey}
        setExamItems={setExamItems}
        prescriptionData={prescriptionData}
        setModalAsOpen={setModalAsOpen}
        modalIsOpen={modalIsOpen}
      />
      <ExamList>
        {examItems.map((exam) => {
          return (
            <BlurCard active={!isUnlockDocumentView} key={exam.id}>
              <ExamItem
                title={exam.classification}
                key={exam.id}
                id={exam.id}
                description={exam.description}
                icon={exam.icon_used_in_the_frontend}
                contactAllowed={exam.concierge_integration}
                allowSchedule={
                  !!exam.allow_contact_suggestion_for_scheduling &&
                  allowScheduleCareplus()
                }
                blockedContent={!prescriptionData}
                scheduleExam={() => handleOpenScheduleModal(exam.id)}
              />
            </BlurCard>
          );
        })}
      </ExamList>
      {!!prescriptionData && (
        <ActionArea>
          {showScheduleButton && !isCareplus && (
            <Link
              href={linkWhatsapp(medicalRecord)}
              onClick={() => handleCloseScheduleModal(true)}
              color="#12893A"
              target="_blank"
              margin={`${Theme.spacing.base} 0 0`}
            >
              <Icon name="whatsapp" size="22px" margin="0 4px 0 0" />
              Agendar via WhatsApp
            </Link>
          )}
          <Button
            margin={`${showScheduleButton ? Theme.spacing.base : '0'} 0 40px 0`}
            onClick={handleOpenPdf}
          >
            <span
              style={{
                marginRight: Theme.spacing.base,
              }}
            >
              Visualizar documentação (PDF)
            </span>
            <Icon name="download" size="20px" color="white" />
          </Button>
        </ActionArea>
      )}
      <ScheduleExamModal
        isScheduleModalOpen={isScheduleModalOpen}
        handleCloseScheduleModal={handleCloseScheduleModal}
        {...modalProps}
      />
      {pdfOpen && (
        <Modal
          isPdfShowing="true"
          widthContainer="100%"
          headerSize="100vw"
          heightContainer="calc(100vh + 300px)"
          isOpen={pdfOpen}
          title={pdfModalTitle}
          onCloseRequest={(event) => {
            event.preventDefault();
            setpdfOpen(false);
          }}
          itens={pdfItems}
          onClickItens={(item) => {
            setpdfItemShowing(item.url);
          }}
        >
          <PdfContainer>
            <Document
              file={pdfItemShowing}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={<LoaderComponent />}
              height="auto"
              width="100vw"
              renderMode="canvas"
            >
              {[1, 2].map((page) => (
                <Page
                  key={`page_${page + 1}`}
                  pageNumber={page >= 0 ? page : 0}
                />
              ))}
            </Document>

            <NotFoundReaderPdfButton>
              <DownloadInMemoryLink url={pdfItemShowing}>
                Fazer o download
              </DownloadInMemoryLink>
            </NotFoundReaderPdfButton>
          </PdfContainer>
        </Modal>
      )}
    </Container>
  );
};

Exam.propTypes = {
  title: PropTypes.string,
  selectedItem: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  validationKey: PropTypes.object.isRequired,
};
Exam.defaultProps = {
  title: 'Solicitação de Exames',
};

export default Exam;
